module.exports = __webpack_public_path__ + "img/team2.b62a2bd3.png";